module.exports = __webpack_public_path__ + "static/media/old-banner.2f6f6e7d.jpg";